import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { adminSetTokens } from 'redux/users/actions';


class AdminSetTokensPage extends PureComponent {

  componentDidMount() {
    const { match: { params } } = this.props;
    this.props.adminSetTokens(
      params.accessToken,
      params.refreshToken,
    );
  }

  componentDidUpdate() {
    if (this.props.accessToken) {
      window.location.href = '/';
    }
  }

  render() {
    return (
      <div>
        <h1>Wait a second...</h1>
      </div>
    );
  }
}


const mapStateToProps = state => (
  {
    accessToken: state.usersReducer.accessToken,
  }
);

export default connect(
  mapStateToProps,
  {
    adminSetTokens,
  },
)(AdminSetTokensPage);
